import { Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export interface StatusMessageProps {
  title: string;
  description: string;
  icon?: ReactNode;
}

export function StatusMessage({
  title,
  description,
  icon,
}: StatusMessageProps) {
  return (
    <Stack my={1}>
      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        gap={2.87}
      >
        {icon && <Stack>{icon}</Stack>}
        <Stack justifyContent="center">
          <Typography
            color="secondary.dark"
            variant="body1"
            sx={(theme) => ({
              fontWeight: theme.typography.fontWeightSemiBold,
            })}
          >
            {title}
          </Typography>
          <Typography variant="body2" color="secondary.main">
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
